import { MainState } from ".."

// manage
export const vehicleSelector = (s: MainState) => s.manager.vehicle
